import CoreLayout from './CoreLayout';

export default CoreLayout;



// WEBPACK FOOTER //
// ./src/layouts/CoreLayout/index.js